var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 2.3125C3.25 1.17341 4.17341 0.25 5.3125 0.25H11.6875C12.8266 0.25 13.75 1.17341 13.75 2.3125V8.695C13.75 9.83409 12.8266 10.7575 11.6875 10.7575H10.75V11.6875C10.75 12.8266 9.82659 13.75 8.6875 13.75H2.3125C1.17341 13.75 0.25 12.8266 0.25 11.6875V5.3125C0.25 4.17341 1.17341 3.25 2.3125 3.25H3.25V2.3125ZM10.75 9.6325V5.3125C10.75 4.17341 9.82659 3.25 8.6875 3.25H4.375V2.3125C4.375 1.79473 4.79473 1.375 5.3125 1.375H11.6875C12.2053 1.375 12.625 1.79473 12.625 2.3125V8.695C12.625 9.21277 12.2053 9.6325 11.6875 9.6325H10.75Z",
    fill: "#121214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b71f29f78b8a91582c24620318320f4a.svg";
export { ForwardRef as ReactComponent };